module.exports = __webpack_public_path__ + "img/closed.6cb007fc.svg";